import { render, staticRenderFns } from "./CedenteCarteira.vue?vue&type=template&id=45f5a2e1"
import script from "./CedenteCarteira.vue?vue&type=script&lang=js"
export * from "./CedenteCarteira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports